<template>
  <div>
    <ReportBooking :loading="isMainLoading" bookingType="monthly"></ReportBooking>
  </div>
</template>

<script>
import ReportBooking from "../../components/ReportBooking.vue";
export default {
  components: { ReportBooking },
  props: {
    isMainLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {}
};
</script>

<style>
</style>